export default "__VITE_ASSET__CJfCc$Rz__"